<script>
import { Line } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler,
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler,
)

export default {
  name: 'Chart',
  extends: Line,
  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    }
  },
  mounted() {
    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: true,
      scales: {
        yAxes: [{
          ticks: {
            max: 0,
            min: 0,
            precision: 0,
          },
        }],
      },
    })
  },
  methods: {
  },
}

</script>
